import { useEffect, useState } from "react";
import SpinningLoader from "./SpinningLoader";

// Tempo até oferecer o botão de recarregar (apps na tela inicial do iOS não têm reload)
const SLOW_LOADING_MS = 12000;

const FullPageLoader = () => {
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), SLOW_LOADING_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-4 text-center">
        <SpinningLoader />
        {slow && (
          <div className="space-y-3 animate-fade-in">
            <p className="text-sm text-slate-600">Está demorando mais que o normal.</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-slate-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-slate-800 focus:ring-2 focus:ring-slate-700/20 focus:outline-none transition-all duration-200"
            >
              Recarregar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FullPageLoader;
